import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.5 16.5V21.5H16.5M21.5 16.5H2.5M21.5 16.5V7.5M2.5 16.5V21.5H7.5M2.5 16.5V7.5M21.5 7.5V2.5H16.5M21.5 7.5H2.5M2.5 7.5V2.5H7.5M7.5 21.5V2.5M7.5 21.5H16.5M7.5 2.5H16.5M16.5 21.5V2.5",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }